import ClaimSetHistoryVisitsServerStorageUpdatedEvent from '@/domains/claimSets/services/ClaimSetHistoryVisitsService/events/ClaimSetHistoryVisitsServerStorageUpdatedEvent';

const ClaimSetHistoryVisitsEvents = {
  StorageUpdated: ClaimSetHistoryVisitsServerStorageUpdatedEvent,
};

export default ClaimSetHistoryVisitsEvents;
